import { FeaturedTestimonialStandard } from "../../../../modules/featured-testimonial/components/FeaturedTestimonialStandard/FeaturedTestimonialStandard";
import type { IFeaturedTestimonialBlockProps } from "./FeaturedTestimonialBlock.props";

export const FeaturedTestimonialBlock = (props: IFeaturedTestimonialBlockProps) => {
  if (!props.eyebrow && !props.heading && !props.description && !props.testimonial?.quote) {
    return null;
  }

  return <FeaturedTestimonialStandard {...props} />;
};

FeaturedTestimonialBlock.displayName = "Block::FeaturedTestimonialBlock";
